import { defineComponent as s, resolveDirective as a, withDirectives as n, openBlock as i, createElementBlock as c, normalizeClass as l, renderSlot as p } from "vue";
const m = /* @__PURE__ */ s({
  __name: "IstPill.vapor",
  props: {
    type: {}
  },
  setup(e) {
    const t = e;
    return (o, v) => {
      const r = a("wave");
      return n((i(), c("span", {
        class: l(["ist-badge", t.type])
      }, [
        p(o.$slots, "default", {}, void 0, !0)
      ], 2)), [
        [r]
      ]);
    };
  }
});
export {
  m as default
};
